'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themeProvider = require('@spp/theme-provider');

var _FeedbackWidget = require('./FeedbackWidget');

var _FeedbackWidget2 = _interopRequireDefault(_FeedbackWidget);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _themeProvider.themer)('@vg/feedback')(_FeedbackWidget2.default);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/feedback/lib/cjs/index.js
 ** module id = 726
 ** module chunks = 1
 **/